export const Types = {
  SAVE_LIST_ROLE: 'SAVE_LIST_ROLE'
}
